<div *transloco="let t" class="flex flex-col overflow-hidden p-4 lg:p-12">
  <div class="text-3xl font-thin">
    {{t('evaluations.myRequests')}}
  </div>
  <div class="grid grid-cols-12">
    <div class="flex flex-col gap-8 col-span-12 lg:col-span-4 overflow-hidden lg:h-available">
      <div class="flex gap-4 items-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-6 h-6">
          <path
            d="M256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28zm7.67-24h-16c-6.627 0-12-5.373-12-12v-.381c0-70.343 77.44-63.619 77.44-107.408 0-20.016-17.761-40.211-57.44-40.211-29.144 0-44.265 9.649-59.211 28.692-3.908 4.98-11.054 5.995-16.248 2.376l-13.134-9.15c-5.625-3.919-6.86-11.771-2.645-17.177C185.658 133.514 210.842 116 255.67 116c52.32 0 97.44 29.751 97.44 80.211 0 67.414-77.44 63.849-77.44 107.408V304c0 6.627-5.373 12-12 12zM256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8z"></path>
        </svg>
        <div class="font-bold text-2xl">{{ t('evaluations.requestList') }}</div>
      </div>
      <div class="border-r border-gray-200 overflow-auto flex lg:flex-col flex-nowrap flex-1">
        @for (artwork of artworks.value()?.data; track artwork.id) {
          @if (artwork.evaluation) {
            <a class="border p-3 border-b-gray-200 flex flex-col flex-shrink-0" [routerLink]="['./', artwork.evaluation.id]">
              <div class="font-bold flex gap-2">
                <div class="font-thin">{{t('common.work')}}:</div> {{ artwork.name }}
              </div>
              <div class="flex items-center gap-2 text-sm">
                <wun-calendar-icon class="block w-2"/>

                <div class="font-thin mt-0.5">
                  {{ t('evaluations.requestDate') }}
                </div>
                <div class="font-bold">
                  {{ artwork.createdAt | date : 'dd.MM.yyyy - hh:mm' }}
                </div>
              </div>

              <wun-media-render class="block !w-24" [media]="artwork.mainAttachment!"/>
            </a>
          }
        }
      </div>
    </div>
    <div class="col-span-12 lg:col-span-8">
      <router-outlet />
    </div>
  </div>

</div>
